import styled from "styled-components";
import { PagesPermissionsManagerUiInput } from "./Input";
import { PagesPermissionsManagerUiResults } from "./Results";
import type { permissionsManagerAPIInterface } from "@dealer-center/ddc-pages-permissions-manager-interface";

const StyledPagesPermissionsManagerUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesPermissionsManagerUiDisplayProps {
  setName: (name: string) => void;
  data?: permissionsManagerAPIInterface;
  error?: string;
  loading: boolean;
  nameInput: string;
  setNameInput: (name: string) => void;
}

export const PagesPermissionsManagerUiDisplay = ({
  data,
  nameInput,
  setName,
  setNameInput,
  error,
  loading
}: PagesPermissionsManagerUiDisplayProps) => {
  return (
    <StyledPagesPermissionsManagerUi>
      <StyledPageHeader>User Permissions Manager</StyledPageHeader>
      <PagesPermissionsManagerUiInput
        loading={loading}
        nameInput={nameInput}
        setName={setName}
        setNameInput={setNameInput}
      />
      <PagesPermissionsManagerUiResults data={data} error={error} />
    </StyledPagesPermissionsManagerUi>
  );
};
